import {INewCustomers} from '../monitor.interface';

export const newCustomersResponseMock: INewCustomers = {
  data: {
    dimensions: [1.7119296e12, 1.7145216e12, 1.7172e12, 1.7304192e12],
    categories: [
      {
        name: 'customer',
        values: [282.0, 4.0, 3.0, 2.0],
        series: [
          {
            name: 'WARNING',
            total: 1.0,
            percentage: 0.003436426116838488,
            values: [0.0, 1.0, 0.0, 0.0]
          },
          {
            name: 'PASSED',
            total: 46.0,
            percentage: 0.15807560137457044,
            values: [43.0, 1.0, 0.0, 2.0]
          },
          {
            name: 'REJECTED',
            total: 244.0,
            percentage: 0.8384879725085911,
            values: [239.0, 2.0, 3.0, 0.0]
          },
          {
            name: 'NOT_EXECUTED',
            total: 10.0,
            percentage: 0.1184879725085911,
            values: [239.0, 2.0, 3.0, 0.0]
          }
        ]
      }
    ],
    total: {
      value: 291.0,
      percentage: 291.0
    },
    average: {
      value: 24.0,
      percentage: 24.0
    }
  },
  context: {
    aggregatorFormat: 'month',
    monitorDataType: 'com.jumio.dashboardeventsaggregator.domain.CategoryMonitor',
    dimensionDataType: 'java.lang.Long',
    seriesDataType: 'java.lang.Double',
    startTime: 1708387200000,
    endTime: 1740009600000,
    historyStartTime: 1676851200000,
    historyEndTime: 1708387200000,
    comparisonPeriodLabel: 'vs Previous Period (2023-02-20 - 2024-02-20)',
    durationInaggregatorFormat: 12,
    processedStartTime: 1740052845341,
    processedEndTime: 1740052845756,
    processedTime: 415
  }
};
